import { render, staticRenderFns } from "./Vendedor.vue?vue&type=template&id=4d0aaeb7&scoped=true&"
import script from "./Vendedor.vue?vue&type=script&lang=js&"
export * from "./Vendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0aaeb7",
  null
  
)

export default component.exports